module.exports = __webpack_public_path__ + "media/apple-quiz-47cd91c8.svg";